import request from '@/axios'

export function getClassDetails (client_user_id, payload) {
  return request({
    url: `/ClientUser/classes/detail/${client_user_id}`,
    method: 'POST',
    data: payload
  })
}

export function SubmitAnswer (payload) {
  return request({
    url: '/ClientUser/classes/submit-answer',
    method: 'POST',
    data: payload
  })
}

export function generateStudentGradebook (payload) {
  return request({
    url: '/ClientUser/classes/gradebook',
    method: 'POST',
    data: payload
  })
}

export function gradebookDownload (payload) {
  return request({
    url: '/ClientUser/classes/gradebook/download/pdf',
    method: 'POST',
    data: payload
  })
}